export default __webpack_public_path__ + "static/media/actions-dont-want-to-watch.24cd25d4.svg";